// @ts-nocheck
import React from 'react'
import styled from 'styled-components'
import MaterialInputLabel from '@material-ui/core/InputLabel'
import TypographyPro from 'themes/TypographyPro'

const StyledInputLabel = styled(TypographyPro)`
	&.MuiFormLabel-root {
		margin-bottom: 5px;
	}

	&.MuiFormLabel-root.Mui-focused {
		color: #000000;
	}
`

const InputLabel = (props) => (
	// return <StyledInputLabel {...props} />
	<TypographyPro variant="BodyRegularHighlighted" component="div">
		{props.children}
	</TypographyPro>
)

export default InputLabel
